import { render } from "./widgets-side-menu.vue?vue&type=template&id=ee789690&scoped=true"
import script from "./widgets-side-menu.vue?vue&type=script&setup=true&lang=js"
export * from "./widgets-side-menu.vue?vue&type=script&setup=true&lang=js"

import "./widgets-side-menu.vue?vue&type=style&index=0&id=ee789690&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee789690"],['__file',"src/components/card-component/widgets-side-menu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ee789690"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ee789690', __exports__)) {
    api.reload('ee789690', __exports__)
  }
  
  module.hot.accept("./widgets-side-menu.vue?vue&type=template&id=ee789690&scoped=true", () => {
    api.rerender('ee789690', render)
  })

}


export default __exports__